import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconResize: React.FC<IconProps> = ({ width = 18, height = 18 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
        >
            <g clip-path="url(#clip0_5923_22632)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.847 0.640934H16.423L16.7939 0.640625V8.58633H16.0524V1.37941L8.847 1.37972V0.640934ZM8.74089 16.5317L1.16489 16.532H0.793945V8.58664H1.53583V15.7932L8.7412 15.7929V16.5317H8.74089ZM3.46448 11.8623H2.72569L2.72074 14.3429L2.72012 14.7129L3.09013 14.7123L5.57071 14.7073V13.9685L3.98578 13.9719L14.232 3.72572L14.2289 5.31066H14.9677L14.9723 2.83008L14.9733 2.46007L14.6029 2.46099L12.1224 2.46594V3.20473L13.7073 3.20133L3.46139 13.4476L3.46448 11.8626V11.8623Z"
                    fill="#303030"
                />
            </g>
            <defs>
                <clipPath id="clip0_5923_22632">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.793945 0.585938)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconResize;
